import { faBoxArchive } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tooltip, Avatar } from "antd"
import { FC } from "react"
import { Translated } from "../../utils/translated"

export const EntityFlagsAvatar: FC<{ entity: { legacy_id: string } }> = ({ entity }) => {
  if (entity.legacy_id !== "") {
    return (
      <Tooltip overlay={<Translated keyEn="H2 Archive Data" />}>
        <Avatar
          // purple
          style={{
            color: "#722ed1", // purple-7
            backgroundColor: "#efdbff", // purple-2
          }}
        >
          <FontAwesomeIcon icon={faBoxArchive} />
        </Avatar>
      </Tooltip>
    )
  }
  return null
}
